import React, { useState } from 'react';

/**
 * Collapsible raw JSON for power users / support.
 * @param {{ title: string, data: unknown, defaultOpen?: boolean }} props
 */
export default function AdminJsonDetails({ title, data, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="admin-hub-kit-json-details">
      <button
        type="button"
        className="admin-hub-kit-json-details__toggle"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        {title}
        <span aria-hidden>{open ? ' ▾' : ' ▸'}</span>
      </button>
      {open ? <pre className="admin-hub-json">{JSON.stringify(data, null, 2)}</pre> : null}
    </div>
  );
}
